import Contact from '../default/Contact'
import Axios from 'axios'
import Config from '@/Config'
import FetcherHelper from '@/helpers/FetcherHelper'

export default class FormCollectDataGW {
  constructor () {
    this.lang = 'fr'
    this.publicId = null
    this.applicant = new Contact()
    this.requestType = {
      isPublic: false,
      isPrivate: false,
      isAcademic: false,
      isOther: false
    }
    this.estimateFrequency = {
      weekly: false,
      monthly: false,
      quarterly: false,
      biannual: false,
      yearly: false,
      multiYear: false
    }
    this.isReccurent = false
    this.projectName = ''
    this.geographicalDescription = ''
    this.dataDescription = ''
    this.otherInfo = ''
  }

  static setPrototype (obj) {
    return obj
  }

  static get apiBaseUrl () {
    return `${Config.apiBaseUrl}/forms/query-data-gw`
  }

  save () {
    return new Promise((resolve, reject) => {
      Axios.post(FormCollectDataGW.apiBaseUrl, this, FetcherHelper.getHeaders())
        .then((response) => {
          resolve()
        }).catch(reject)
    })
  }
}
